export default "__VITE_ASSET__BpfnqZUC__"